<template>
  <table
    class="admin-table-structure"
  >
    <thead>
      <th data-type="numeric">
        Sewist
        <span class="resize-handle"></span>
      </th>
      <th data-type="text-short">
        Request #
        <span class="resize-handle"></span>
      </th>
      <th data-type="text-short">
        Request Date
        <span class="resize-handle"></span>
      </th>
      <th data-type="text-short">
        Masks
        <span class="resize-handle"></span>
      </th>
      <th data-type="text-long">
        Caps
        <span class="resize-handle"></span>
      </th>
      <th data-type="text-long">
        Other
        <span class="resize-handle"></span>
      </th>
    </thead>
  </table>
</template>
<script>
export default {
  name: "AdminTableHeader"
};
</script>
<style lang="scss" scoped>
</style>